import Input from "../../Components/CommonCommponents/Input";
import Select from "../../Components/CommonCommponents/select/Select";
import { isEmpty } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, message } from "antd";
import AuthService from "../../Service.js/authService";
import toast from "react-hot-toast";
import CandodateService from "../../Service.js/CandidateService";

const ResumeFieldBasicDetails = (props) => {
  const [messageApi, messageContextHolder] = message.useMessage();

  const {
    clearErrors,
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    setError,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: {},
  });
  const [languages, setLanguages] = useState();
  const fieldVisible = (name) => {
    const { fields } = props;
    let value = false;
    if (fields?.includes(name)) {
      value = true;
    }
    return value;
  };
  const handleLangages = async (serachValue) => {
    await AuthService.getLanguages(serachValue)
      .then((response) => {
        setLanguages(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSubmit = async (data) => {
    console.log(data, "datadata");

    let result = {};

    let keysData = Object.keys(data);
    keysData?.map((k) => {
      if (fieldVisible(k)) {
        if (k === "languages") {
          const idsArray = data[k]?.map((obj) => obj.key);
          result[k] = idsArray;
        } else {
          result[k] = data[k];
        }
      }
    });
    console.log(result, "resultresult");
    await CandodateService.updatecandidaetDetails(result, props.userId)
      .then(
        (oResponse) => {
          toast.success("Successfully Updated!");
          props?.setEnable(true);
          props?.setRequiredFields([]);
        },
        (error) => {
          const errorsObj = error?.response?.data?.error_info;

          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
        }
      )
      .catch((error) => {
        toast.error("Failed To Update");
      });
  };
  return (
    <>
      <div className="edit_candidate_maindiv">
        {messageContextHolder}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="editCandidate_form w-full">
            <div
              className={`form_content ${
                fieldVisible("total_exp") ? "block" : "hidden"
              }`}
            >
              <Input
                name="total_exp"
                label={
                  <p>
                    Total Experience<span className="text-errorMain">*</span>
                  </p>
                }
                control={control}
                placeholder="total_exp"
                rules={{
                  required: fieldVisible("total_exp")
                    ? "This field is required"
                    : false,
                }}
              />
            </div>
            <div
              className={`form_content ${
                fieldVisible("languages") ? "block" : "hidden"
              }`}
            >
              <Select
                allowClear
                showSearch
                showArrow={true}
                control={control}
                name="languages"
                mode={"multiple"}
                placeholder="Spoken Languages"
                label={<p>Known Languages</p>}
                options={languages?.results?.map((oOption) => {
                  return {
                    value: oOption.id,
                    label: oOption.language,
                  };
                })}
                onSearch={(value) => handleLangages(value)}
                onClear={() => {
                  setValue("languages", undefined);
                }}
              />
            </div>
          </div>
          <div className="float-right mt-4">
            <Button type="primary" className="ml-4" htmlType="submit">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};
export default ResumeFieldBasicDetails;
